import { combineReducers } from 'redux';
import appReducer from './app';
import authReducer from './auth';
import quizReducer from './quiz';

const rootReducer = combineReducers({
  app: appReducer,
  auth: authReducer,
  quiz: quizReducer,
});

export default rootReducer;
